import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { promoCodes } from 'src/constants/promoCodes'
export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    title="Stream Live TV & Sports"
    subtitle={
      <>
        Enjoy a special offer through Corestream.
        <br />
        Save $25/mo off your first two months.
      </>
    }
    offerCode={promoCodes.corestream}
    logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-corestream.png"
    noIndex={true}
  />
)
